import type { MatomoSettings } from '@ahd/shared/types/tracking/matomo/website-settings/types';

import axios from 'axios';

import { srUrl } from '../../vars';

import type { DebugLevel } from '../../_configs/types';

export const getMatomoSettings = (idGroup: number, domain: string, debug: DebugLevel) =>
    axios<MatomoSettings>({
        debug,
        idGroup,
        noLogging: true,
        method: 'get',
        url: `${srUrl}/tracking/matomo-settings/${domain === 'localhost' ? 'ahd-dev.autohaus-digital.de' : domain?.replace('www.', '')}`,
        timeout: 5000,
    });
